import type { LatLng } from "../../data/api/types";

// Plain map defaults live separately so application state can use them without
// loading the Mapbox implementation on pages that do not display a map.
export const AUcenter: LatLng = { lat: -28.25, lng: 133.416667 };
